import { render, staticRenderFns } from "./EscalationMatrixList.vue?vue&type=template&id=ab30dace&scoped=true"
import script from "./EscalationMatrixList.vue?vue&type=script&lang=js"
export * from "./EscalationMatrixList.vue?vue&type=script&lang=js"
import style0 from "./EscalationMatrixList.vue?vue&type=style&index=0&id=ab30dace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab30dace",
  null
  
)

export default component.exports